import React, { useState } from "react";
import { Button, Check, Edit05, TextInput, XClose } from "@opendate-app/setlist";

import { useActionContext } from "./ActionContainer";
import TemplateEditor from "../../BeefreeTemplates/TemplateEditor";

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  border: "1px solid var(--sl-border-secondary)",
  borderRadius: 12,
  overflow: "hidden",
};

const headerRowStyle = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: 16,
  padding: 16,
  fontSize: 14,
  color: "var(--sl-text-secondary)",
  background: "var(--sl-bg-primary)",
  borderBottom: "1px solid var(--sl-border-secondary)",
};

const recipientLineStyle = {
  maxWidth: "33%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const inlineFormStyle = {
  display: "flex",
  alignItems: "center",
  gap: 4,
  margin: 0,
};

const EmailContentTab = () => {
  const {
    action,
    updateAction,
    autosaveTemplate,
    subject,
    setSubject,
    sendDomain,
  } = useActionContext();

  const [isEditingSubject, setIsEditingSubject] = useState(false);

  const updateSubject = () => {
    setIsEditingSubject(false);
    updateAction({
      campaign_action: {
        subject: subject
      }
    })
  };

  const cancelSubjectEdit = () => {
    setSubject(action.subject);
    setIsEditingSubject(false);
  };

  return (
    <div style={containerStyle}>
      <div style={headerRowStyle}>
        <div><b>From: </b>{sendDomain?.name_with_address}</div>
        <div style={recipientLineStyle}><b>To: </b>{action.recipient}</div>
        <form style={inlineFormStyle} onSubmit={(e) => {
          e.preventDefault();
          updateSubject();
        }}>
          <b>Subject: </b>
          {isEditingSubject ? (
            <>
              <div style={{ width: 400, maxWidth: "60vw" }}>
                <TextInput
                  size="sm"
                  autoFocus
                  aria-label="Subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />
              </div>
              <Button key="save" type="submit" variant="tertiary" size="xs" icon={Check} aria-label="Save subject" />
              <Button key="cancel" variant="tertiary" size="xs" icon={XClose} aria-label="Cancel subject edit" onClick={cancelSubjectEdit} />
            </>
          ) : (
            <>
              {subject}
              <Button key="edit" variant="tertiary" size="xs" icon={Edit05} aria-label="Edit subject" onClick={() => setIsEditingSubject(true)} />
            </>
          )}
        </form>
      </div>
      <TemplateEditor
        templatableContext={useActionContext}
        autosave
        onAutosave={autosaveTemplate}
        mergeTags={[
          {
            name: "Fan First Name",
            value: "{{fan.first_name}}"
          },
          {
            name: "Fan Last Name",
            value: "{{fan.last_name}}"
          },
          {
            name: "Fan Full Name",
            value: "{{fan.full_name}}"
          },
          {
            name: "Fan Phone Number",
            value: "{{fan.phone_number}}"
          },
          {
            name: "Fan Email",
            value: "{{fan.email}}"
          },
          {
            name: "Event Name",
            value: "{{event.name}}"
          },
          {
            name: "Event Presenter",
            value: "{{event.presenter}}"
          },
          {
            name: "Event Description",
            value: "{{event.description}}"
          },
          {
            name: "Event Headliners",
            value: "{{event.headliners}}"
          },
          {
            name: "Event Support Acts",
            value: "{{event.support_acts}}"
          },
          {
            name: "Event Age Restriction",
            value: "{{event.age_restriction}}"
          },
          {
            name: "Event Image Url",
            value: "{{event.image}}"
          },
          {
            name: "Event Url",
            value: "{{event.url}}"
          },
          {
            name: "Event Announce Date",
            value: "{{event.announce_date}}"
          },
          {
            name: "Event Announce Time",
            value: "{{event.announce_time}}"
          },
          {
            name: "Event Announce Date and Time",
            value: "{{event.announce_date_and_time}}"
          },
          {
            name: "Event Announce Time Object",
            value: "{{event.announce_time_obj}}"
          },
          {
            name: "Event Start Date",
            value: "{{event.start_date}}"
          },
          {
            name: "Event Start Time",
            value: "{{event.start_time}}"
          },
          {
            name: "Event Start Date and Time",
            value: "{{event.start_date_and_time}}"
          },
          {
            name: "Event Start Time Object",
            value: "{{event.start_time_obj}}"
          },
          {
            name: "Event Door Date",
            value: "{{event.door_date}}"
          },
          {
            name: "Event Door Time",
            value: "{{event.door_time}}"
          },
          {
            name: "Event Door Date and Time",
            value: "{{event.door_date_and_time}}"
          },
          {
            name: "Event Door Time Object",
            value: "{{event.door_time_obj}}"
          },
          {
            name: "Event End Date",
            value: "{{event.end_date}}"
          },
          {
            name: "Event End Time",
            value: "{{event.end_time}}"
          },
          {
            name: "Event End Date and Time",
            value: "{{event.end_date_and_time}}"
          },
          {
            name: "Event Sales Start Date",
            value: "{{event.sales_start_date}}"
          },
          {
            name: "Event Sales Start Time",
            value: "{{event.sales_start_time}}"
          },
          {
            name: "Event Sales Start Date and Time",
            value: "{{event.sales_start_date_and_time}}"
          },
          {
            name: "Event Sales Start Time Object",
            value: "{{event.sales_start_time_obj}}"
          },
          {
            name: "Venue Pre-Sale Promo Code",
            value: "{{event.venue_pre_sale_promo_code}}"
          },
          {
            name: "Venue Pre-Sale Date",
            value: "{{event.venue_pre_sale_date}}"
          },
          {
            name: "Venue Pre-Sale Time",
            value: "{{event.venue_pre_sale_time}}"
          },
          {
            name: "Venue Pre-Sale Date and Time",
            value: "{{event.venue_pre_sale_date_and_time}}"
          },
          {
            name: "Venue Name",
            value: "{{venue.name}}"
          },
          {
            name: "Venue Address",
            value: "{{venue.address}}"
          },
          {
            name: "Venue Logo URL",
            value: "{{venue.logo}}"
          },
        ]}
      />
    </div>
  );
};

export default EmailContentTab;
